import { useState } from 'react';

const faqs = [
  {
    q: '諮詢全程使用哪種語言進行？',
    a: '根據你的需求，NexusGo 導師可以用中文（普通話）或英文進行諮詢。大多數學員選擇中文諮詢，但如果希望練習外商英文面試表達，也可以全程英文進行。',
  },
  {
    q: '如果我對諮詢效果不滿意，可以退款嗎？',
    a: 'NexusGo 提供 100% 滿意保障。如果諮詢結束後 48 小時內你認為諮詢品質未達到預期，可申請全額退款，無需提供任何理由。',
  },
  {
    q: '一次諮詢通常能解決什麼問題？',
    a: '這取決於你的目標。一次 1V1 職涯諮詢（60 分鐘）通常可以完成：職業現狀深度診斷、目標外商職缺路徑分析、近期行動計畫制定。建議第一次諮詢專注於一個核心目標，以確保深度和效果。',
  },
  {
    q: '我需要提前準備什麼嗎？',
    a: '預約確認後，我們會傳送一份簡短的諮詢前問卷（約 5 分鐘完成），包括你的職業背景、目標公司和期望解決的核心問題。導師會根據這些資訊提前準備，讓諮詢時間的每一分鐘都有價值。',
  },
  {
    q: '諮詢後還有後續支援嗎？',
    a: '是的！所有套餐均包含諮詢後的電子郵件支援：1V1 諮詢 14 天，面試衝刺套餐含面試當天即時支援，全能套餐提供 60 天持續追蹤。NexusGo 團隊希望看到你真正拿到 Offer，而不只是完成諮詢。',
  },
  {
    q: '如何確認導師的真實背景？',
    a: 'NexusGo 對所有導師進行嚴格的背景審查，包括 LinkedIn 檔案驗證、公司信箱確認及電話訪談。平台所有導師均通過三重驗證，並持有 NexusGo 認證徽章，確保背景真實可信。',
  },
];

const ServiceFaq = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-16 bg-slate-50">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold text-violet-600 tracking-widest uppercase mb-3 block">
            常見問題
          </span>
          <h2 className="text-2xl font-bold text-navy-800 tracking-tight">
            你可能想了解的一切
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border border-slate-100 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-slate-50 transition-colors"
              >
                <span className="font-semibold text-navy-800 text-sm pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-slate-400 transition-transform ${
                      openIdx === i ? 'rotate-180' : ''
                    }`}
                  />
                </div>
              </button>

              {openIdx === i && (
                <div className="px-6 pb-5">
                  <p className="text-slate-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceFaq;
